import type {
    ColorSwatchPickerNavigationConstantType,
    ColorSwatchPickerTabStopConstantType,
    ColorSwatchPickerMatchConstantType
} from "./type";
import {
    parseColorString,
    formatColorHex
} from "../../helpers/color";
import {
    getHorizontalStep
} from "../../helpers/direction";

export const COLOR_SWATCH_PICKER_DEFAULT_COLUMNS = 8;

export const COLOR_SWATCH_PICKER_NAVIGATION_KEYS: Array<string> = [
    "ArrowRight",
    "ArrowLeft",
    "ArrowDown",
    "ArrowUp",
    "Home",
    "End"
];

export const getColorSwatchPickerIsMatch = ({
    value,
    color
}: ColorSwatchPickerMatchConstantType): boolean => {
    if(value === undefined) {
        return false;
    }

    const first = parseColorString(value);

    const second = parseColorString(color);

    if(!first || !second) {
        return value === color;
    }

    return formatColorHex({
        ...first,
        isAlphaEnabled: true
    }) === formatColorHex({
        ...second,
        isAlphaEnabled: true
    });
};

export const getColorSwatchPickerNextIndex = ({
    direction,
    columns,
    layout,
    count,
    index,
    key
}: ColorSwatchPickerNavigationConstantType): number | null => {
    if(key === "Home") {
        return 0;
    }

    if(key === "End") {
        return count - 1;
    }

    let step = getHorizontalStep({
        direction,
        key
    }) as number;

    if(key === "ArrowDown" || key === "ArrowUp") {
        const unit = layout === "grid" ? columns : 1;

        step = key === "ArrowDown" ? unit : -unit;
    }

    const next = index + step;

    if(step === 0 || next < 0 || next >= count) {
        return null;
    }

    return next;
};

export const getColorSwatchPickerTabStop = ({
    selectedIndex,
    lastFocused,
    isDisabled,
    count
}: ColorSwatchPickerTabStopConstantType): number => {
    if(isDisabled || count === 0) {
        return -1;
    }

    if(lastFocused !== null && lastFocused < count) {
        return lastFocused;
    }

    return selectedIndex >= 0 ? selectedIndex : 0;
};
